import type { PropsWithChildren } from "react";
import React from "react";
import { twMerge } from "tailwind-merge";

import type { Styled } from "~/utils";

export const CenteredContainer = ({
  className,
  children,
}: PropsWithChildren<Styled>) => {
  return (
    <div
      className={twMerge(
        "flex h-full w-full flex-1 items-center justify-center self-center justify-self-center pb-16",
        className,
      )}
    >
      {children}
    </div>
  );
};
